import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { CommonService } from 'src/app/common.service';
import { MustBeAfter } from '../utils/must-be-after.validator'
import { InlineResponse200, Profile, PaymentMethod } from 'profile-api';
import { Tender } from 'tender-api';
import * as moment from 'moment';
import { Router } from '@angular/router';

@Component({
    selector: 'app-quote-request',
    templateUrl: './quote-request.component.html',
    styleUrls: ['./quote-request.component.css']
})
export class QuoteRequestComponent implements OnInit {
    newTenderForm: FormGroup;
    loading = false;
    error: string = "no_error";
    categoryError: string = "no_error";
    provinces = null;
    startDateAlert: string = "";
    endDateAlert: string = "";
    constructionBox: string = "";
    renovationBox: string = "";
    systemBox: string = "";
    excavationBox: string = "";
    demolitionBox: string = "";

    tenderCategory: Tender.CategoryCodeEnum = null;

    constructor(
        private commonService: CommonService,
        private formBuilder: FormBuilder,
        private router: Router
    ) { }

    ngOnInit(): void {
        window['moment'] = moment;

        this.newTenderForm = this.formBuilder.group({
            title: new FormControl('', [Validators.required]),
            description: new FormControl('', [Validators.required]),
            provinceCode: new FormControl('', [Validators.required]),
            startDate: new FormControl('', [Validators.required]),
            endDate: new FormControl('', [Validators.required])
        }, {
            validator: MustBeAfter('startDate', 'endDate')
        });

        this.commonService.getProvinces().then(
            (provinceList: InlineResponse200) => {
                this.provinces = provinceList;
            }
        ).catch(
            (error) => {
                this.error = "Impossibile caricare la lista delle province.";
                console.log(error);
            }
        );


        let startDateControl = this.newTenderForm.get('startDate');
        startDateControl.valueChanges.subscribe(
            date => {
                if (startDateControl.invalid) {
                    this.startDateAlert = "ng-date-container-alert";
                } else {
                    this.startDateAlert = "";
                    this.resetError();
                }
            }
        );

        let endDateControl = this.newTenderForm.get('endDate');
        endDateControl.valueChanges.subscribe(
            date => {
                setTimeout(() => {
                    if (endDateControl.invalid) {
                        this.endDateAlert = "ng-date-container-alert";
                    } else {
                        this.endDateAlert = "";
                        this.resetError();
                    }
                })

            }
        );
    }

    resetCategoryBox() {
        this.constructionBox = "";
        this.renovationBox = "";
        this.systemBox = "";
        this.excavationBox = "";
        this.demolitionBox = "";
        this.categoryError = "no_error";
        this.resetError();
    }

    selectConstruction() {
        this.tenderCategory = Tender.CategoryCodeEnum.Construction;
        this.resetCategoryBox();
        this.constructionBox = "ng-selected-category-box";
    }

    selectRenovation() {
        this.tenderCategory = Tender.CategoryCodeEnum.Renovation;
        this.resetCategoryBox();
        this.renovationBox = "ng-selected-category-box";
    }

    selectSystem() {
        this.tenderCategory = Tender.CategoryCodeEnum.System;
        this.resetCategoryBox();
        this.systemBox = "ng-selected-category-box";
    }

    selectExcavation() {
        this.tenderCategory = Tender.CategoryCodeEnum.Excavation;
        this.resetCategoryBox();
        this.excavationBox = "ng-selected-category-box";
    }

    selectDemolition() {
        this.tenderCategory = Tender.CategoryCodeEnum.Demolition;
        this.resetCategoryBox();
        this.demolitionBox = "ng-selected-category-box";
    }


    newTenderSubmitHandler() {
        this.loading = true;
        if (!this.newTenderForm.valid || this.tenderCategory === null || this.tenderCategory === undefined) {
            this.error = "I campi non sono compilati correttamente.";
            const controls = this.newTenderForm.controls;
            Object.keys(controls).forEach(controlName => controls[controlName].markAsDirty());
            if (this.tenderCategory === null || this.tenderCategory === undefined) {
                this.categoryError = "Selezionare una categoria.";
            } else {
                this.categoryError = "no_error";
            }

            if (this.newTenderForm.get('startDate').invalid) {
                this.startDateAlert = "ng-date-container-alert";
            } else {
                this.startDateAlert = "";
            }

            if (this.newTenderForm.get('endDate').invalid) {
                this.endDateAlert = "ng-date-container-alert";
            } else {
                this.endDateAlert = "";
            }

            console.log("Invalid new tender form");
            this.loading = false;
            return;
        }

        let formValues = this.newTenderForm.getRawValue();
        delete formValues.startDate;
        delete formValues.endDate;
        console.log(formValues);

        let newTender: Tender = formValues;

        newTender.categoryCode = this.tenderCategory;

        let expectedStartDate = moment(this.newTenderForm.get('startDate').value);
        newTender.expectedStartDate = expectedStartDate.format('YYYY-MM-DD');
        let expectedEndDate = moment(this.newTenderForm.get('endDate').value);
        newTender.expectedEndDate = expectedEndDate.format('YYYY-MM-DD');

        localStorage.setItem('TEMP_TENDER', JSON.stringify(newTender));


        this.commonService.getProfile().then((profile: Profile) => {
            this.commonService.saveProfile(profile).then(
                (pro: Profile) => {
                    this.commonService.getPaymentMethodService().profilePaymentMethodGet().subscribe(
                        (paymentMethod: PaymentMethod) => {
                            this.router.navigate(['/acquistarichiestapreventivo']);
                        },
                        (error) => {
                            this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'paymentMethod', "fromQuoteBuy": 'yes' } });
                        }
                    )
                }
            ).catch(
                (error) => {
                    this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'profile', "fromQuoteBuy": 'yes' } });
                }
            );
        }).catch(
            (error) => {
                console.log("User not logged in. Redirect to login")
                console.log(error);
                this.router.navigate(['/login'], { queryParams: { "fromQuoteBuy": 'yes' } });
            }
        );
    }

    resetError() {
        this.error = 'no_error';
    }
}
